export type PermissionKey = string;

export const permissionScopeValues = ['company', 'platform'] as const;
export type PermissionScope = (typeof permissionScopeValues)[number];

export interface PermissionDto {
  key: PermissionKey;
  description: string;
  scope: PermissionScope;
}

export interface ListPermissionsResponse {
  items: PermissionDto[];
}

export const REPORTS_VIEW_PERMISSION: PermissionKey = 'reports.view';

export const CASH_SESSION_OPEN_PERMISSION: PermissionKey = 'cash.session.open';
export const CASH_SESSION_CLOSE_PERMISSION: PermissionKey = 'cash.session.close';
export const CASH_SESSION_VIEW_PERMISSION: PermissionKey = 'cash.session.view';
export const CASH_SESSION_FORCE_CLOSE_PERMISSION: PermissionKey = 'cash.session.forceClose';
export const CASH_TRANSFER_DRAWER_TO_DRAWER_PERMISSION: PermissionKey =
  'cash.transfer.drawerToDrawer';
export const CASH_TRANSFER_DRAWER_TO_DRAWER_REVERSE_PERMISSION: PermissionKey =
  'cash.transfer.drawerToDrawer.reverse';
export const CASH_DRAWER_REFILL_PERFORM_PERMISSION: PermissionKey = 'cash.drawerRefill.perform';
export const CASH_DRAWER_REFILL_SELF_PERFORM_PERMISSION: PermissionKey =
  'cash.drawerRefill.selfPerform';
export const CASH_DROP_PERFORM_PERMISSION: PermissionKey = 'cash.drop.perform';
export const CASH_EXPENSE_CREATE_PERMISSION: PermissionKey = 'cash.expense.create';
export const CASH_EXPENSE_VOID_PERMISSION: PermissionKey = 'cash.expense.void';
export const CASH_EXPENSE_CORRECT_METADATA_PERMISSION: PermissionKey =
  'cash.expense.correctMetadata';
export const CASH_VAULT_VIEW_PERMISSION: PermissionKey = 'cash.vault.view';
export const CASH_VAULT_COUNT_PERMISSION: PermissionKey = 'cash.vault.count';
export const CASH_VAULT_INTAKE_PERMISSION: PermissionKey = 'cash.vault.intake';
export const CASH_VAULT_EXPENSE_CREATE_PERMISSION: PermissionKey = 'cash.vault.expense.create';
export const CASH_VAULT_EXPENSE_VOID_PERMISSION: PermissionKey = 'cash.vault.expense.void';
export const CASH_VAULT_EXPENSE_CORRECT_METADATA_PERMISSION: PermissionKey =
  'cash.vault.expense.correctMetadata';
export const CASH_TREASURY_VIEW_PERMISSION: PermissionKey = 'cash.treasury.view';
export const CASH_TREASURY_FUND_PERMISSION: PermissionKey = 'cash.treasury.fund';
export const CASH_TREASURY_EXPENSE_CREATE_PERMISSION: PermissionKey =
  'cash.treasury.expense.create';
export const CASH_TREASURY_EXPENSE_VOID_PERMISSION: PermissionKey = 'cash.treasury.expense.void';
export const CASH_TREASURY_EXPENSE_CORRECT_METADATA_PERMISSION: PermissionKey =
  'cash.treasury.expense.correctMetadata';
export const CASH_TREASURY_COUNT_PERMISSION: PermissionKey = 'cash.treasury.count';
export const CASH_TREASURY_COUNT_STARTING_PERMISSION: PermissionKey =
  'cash.treasury.count.starting';
export const CASH_TREASURY_COUNT_OVERRIDE_PERMISSION: PermissionKey =
  'cash.treasury.count.override';
export const CASH_LOCATION_MANAGE_PERMISSION: PermissionKey = 'cash.location.manage';
export const CASH_NEEDED_REQUEST_CREATE_PERMISSION: PermissionKey = 'cash.cashNeededRequest.create';
export const CASH_NEEDED_REQUEST_VIEW_PERMISSION: PermissionKey = 'cash.cashNeededRequest.view';
export const CASH_NEEDED_REQUEST_CANCEL_PERMISSION: PermissionKey = 'cash.cashNeededRequest.cancel';
export const CASH_TREASURY_DISTRIBUTION_CREATE_PERMISSION: PermissionKey =
  'cash.treasuryDistribution.create';
export const CASH_TREASURY_DISTRIBUTION_CANCEL_PERMISSION: PermissionKey =
  'cash.treasuryDistribution.cancel';
export const CASH_VARIANCE_VIEW_PERMISSION: PermissionKey = 'cash.variance.view';
export const CASH_VARIANCE_SUBMIT_PERMISSION: PermissionKey = 'cash.variance.submit';
export const CASH_VARIANCE_REVIEW_PERMISSION: PermissionKey = 'cash.variance.review';
export const CASH_VARIANCE_WRITEOFF_PERMISSION: PermissionKey = 'cash.variance.writeoff';
export const CASH_VARIANCE_OFFSET_PERMISSION: PermissionKey = 'cash.variance.offset';
export const CASH_VARIANCE_CLASSIFY_PERMISSION: PermissionKey = 'cash.variance.classify';
export const CASH_DENOMINATIONS_CORRECT_OWN_PERMISSION: PermissionKey =
  'cash.denominations.correctOwn';
export const CASH_DENOMINATIONS_CORRECT_CUSTODY_PERMISSION: PermissionKey =
  'cash.denominations.correctCustody';
export const CASH_TREASURY_DELIVERY_RECEIVE_MATCHED_PERMISSION: PermissionKey =
  'cash.treasuryDelivery.receiveMatched';
export const CASH_TREASURY_DELIVERY_RECEIVE_PROVISIONAL_PERMISSION: PermissionKey =
  'cash.treasuryDelivery.receiveProvisional';
export const CASH_TREASURY_DELIVERY_RECONCILE_PERMISSION: PermissionKey =
  'cash.treasuryDelivery.reconcile';
export const CASH_LOCAL_CUSTODY_CORRECT_PERMISSION: PermissionKey = 'cash.localCustody.correct';
export const CASH_LOCAL_CUSTODY_REVERSE_PERMISSION: PermissionKey = 'cash.localCustody.reverse';
export const CASH_LOCAL_CUSTODY_VIEW_PERMISSION: PermissionKey = 'cash.localCustody.view';
export const CASH_OPERATING_MODEL_MANAGE_PERMISSION: PermissionKey = 'cash.operatingModel.manage';
export const CASH_REMITTANCE_DESTINATION_MANAGE_PERMISSION: PermissionKey =
  'cash.remittanceDestination.manage';
export const CASH_MODE_ACTIVATION_PERFORM_PERMISSION: PermissionKey = 'cash.modeActivation.perform';
export const CASH_MODE_ACTIVATION_PERFORM_TREASURY_PERMISSION: PermissionKey =
  'cash.modeActivation.performTreasury';
export const CASH_VAULT_REMITTANCE_CREATE_PERMISSION: PermissionKey = 'cash.vaultRemittance.create';
export const CASH_VAULT_REMITTANCE_PREPARE_PERMISSION: PermissionKey =
  'cash.vaultRemittance.prepare';
export const CASH_VAULT_REMITTANCE_HANDOFF_PERMISSION: PermissionKey =
  'cash.vaultRemittance.handoff';
export const CASH_VAULT_REMITTANCE_CANCEL_PERMISSION: PermissionKey = 'cash.vaultRemittance.cancel';
export const CASH_VAULT_REMITTANCE_CONFIRM_DESTINATION_PERMISSION: PermissionKey =
  'cash.vaultRemittance.confirmDestination';
export const CASH_VAULT_REMITTANCE_RETURN_PERMISSION: PermissionKey = 'cash.vaultRemittance.return';
export const CASH_VAULT_REMITTANCE_EXCEPTION_PERMISSION: PermissionKey =
  'cash.vaultRemittance.exception';
export const CASH_VAULT_REMITTANCE_VOID_PERMISSION: PermissionKey = 'cash.vaultRemittance.void';
export const CASH_VAULT_REMITTANCE_RECEIVE_TREASURY_PERMISSION: PermissionKey =
  'cash.vaultRemittance.receiveTreasury';
export const STATIONS_RECOVER_PERMISSION: PermissionKey = 'stations.recover';
export const STATION_SYNC_PERMISSION: PermissionKey = 'station.sync';
export const UNIT_PROFILES_VIEW_PERMISSION: PermissionKey = 'unitProfiles.view';
export const UNIT_PROFILES_MANAGE_PERMISSION: PermissionKey = 'unitProfiles.manage';
export const TARE_PROFILES_VIEW_PERMISSION: PermissionKey = 'tareProfiles.view';
export const TARE_PROFILES_MANAGE_PERMISSION: PermissionKey = 'tareProfiles.manage';
export const HOLDING_UNITS_ACTIVITY_VIEW_PERMISSION: PermissionKey = 'holdingUnits.activity.view';
export const HOLDING_UNITS_AUDIT_VIEW_PERMISSION: PermissionKey = 'holdingUnits.audit.view';
export const SHIPMENTS_WEIGH_EVIDENCE_VIEW_PERMISSION: PermissionKey =
  'shipments.weighEvidence.view';
export const SHIPMENTS_WEIGH_EVIDENCE_DRIVER_VIEW_PERMISSION: PermissionKey =
  'shipments.weighEvidence.driverView';
export const SHIPMENTS_WEIGH_EVIDENCE_CAPTURE_PERMISSION: PermissionKey =
  'shipments.weighEvidence.capture';
export const SHIPMENTS_WEIGH_EVIDENCE_REVIEW_PERMISSION: PermissionKey =
  'shipments.weighEvidence.review';
export const SHIPMENTS_WEIGH_EVIDENCE_MANAGE_PERMISSION: PermissionKey =
  'shipments.weighEvidence.manage';
export const SHIPMENTS_WEIGH_EVIDENCE_SECURE_LINK_MANAGE_PERMISSION: PermissionKey =
  'shipments.weighEvidence.secureLink.manage';
export const SHIPMENTS_DRIVER_ASSIGNMENT_VIEW_PERMISSION: PermissionKey =
  'shipments.driverAssignment.view';
export const SHIPMENTS_DRIVER_ASSIGNMENT_MANAGE_PERMISSION: PermissionKey =
  'shipments.driverAssignment.manage';
export const SHIPMENTS_REVERSE_DEPARTURE_PERMISSION: PermissionKey = 'shipments.reverseDeparture';
export const PURCHASES_SETTLEMENT_CHECK_PERMISSION: PermissionKey = 'purchases.settlement.check';
export const PURCHASES_SETTLEMENT_VOUCHER_PERMISSION: PermissionKey =
  'purchases.settlement.voucher';
export const PURCHASES_SETTLEMENT_OVERRIDE_PERMISSION: PermissionKey =
  'purchases.settlement.override';
export const PURCHASES_SETTINGS_MANAGE_PERMISSION: PermissionKey = 'purchases.settings.manage';
export const DORIIS_REPORTS_VIEW_PERMISSION: PermissionKey = 'doriisReports.view';
export const DORIIS_REPORTS_IMPORT_PERMISSION: PermissionKey = 'doriisReports.import';
export const DORIIS_REPORTS_MANUAL_CREATE_PERMISSION: PermissionKey = 'doriisReports.manualCreate';
export const DORIIS_REPORTS_LINK_PERMISSION: PermissionKey = 'doriisReports.link';
export const DORIIS_REPORTS_ENRICH_PERMISSION: PermissionKey = 'doriisReports.enrich';
export const DORIIS_REPORTS_UNLINK_PERMISSION: PermissionKey = 'doriisReports.unlink';
export const PLATFORM_SYSTEM_VIEW_PERMISSION: PermissionKey = 'platform.system.view';
export const PLATFORM_SYSTEM_MANAGE_PERMISSION: PermissionKey = 'platform.system.manage';
export const PLATFORM_AUDIT_VIEW_PERMISSION: PermissionKey = 'platform.audit.view';
export const PLATFORM_GRANTS_VIEW_PERMISSION: PermissionKey = 'platform.grants.view';
export const PLATFORM_GRANTS_MANAGE_PERMISSION: PermissionKey = 'platform.grants.manage';
export const PLATFORM_STATION_DIAGNOSTICS_VIEW_PERMISSION: PermissionKey =
  'platform.stationDiagnostics.view';
export const PLATFORM_MATERIAL_CATALOG_VIEW_PERMISSION: PermissionKey =
  'platform.materialCatalog.view';
export const PLATFORM_MATERIAL_CATALOG_MANAGE_PERMISSION: PermissionKey =
  'platform.materialCatalog.manage';
export const PLATFORM_BILLING_CATALOG_MANAGE_PERMISSION: PermissionKey =
  'platform.billingCatalog.manage';
export const PLATFORM_BILLING_CATALOG_ENTITLEMENTS_MANAGE_PERMISSION: PermissionKey =
  'platform.billingCatalog.entitlements.manage';

export const DORIIS_REPORTS_BASIC_FEATURE = 'doriisReports.basic';

export const HOLDING_UNITS_BUSINESS_ACTIVITY_PERMISSION_KEYS: readonly PermissionKey[] = [
  'holdingUnits.manage',
  HOLDING_UNITS_ACTIVITY_VIEW_PERMISSION,
];

export const HOLDING_UNITS_INVENTORY_POLICY_READ_PERMISSION_KEYS: readonly PermissionKey[] = [
  'shipments.view',
  'coverShipments.view',
  'holdingUnits.view',
  'holdingUnits.manage',
];

export const CASH_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_SESSION_OPEN_PERMISSION,
  CASH_SESSION_CLOSE_PERMISSION,
  CASH_SESSION_VIEW_PERMISSION,
  CASH_SESSION_FORCE_CLOSE_PERMISSION,
  CASH_TRANSFER_DRAWER_TO_DRAWER_PERMISSION,
  CASH_TRANSFER_DRAWER_TO_DRAWER_REVERSE_PERMISSION,
  CASH_DRAWER_REFILL_PERFORM_PERMISSION,
  CASH_DRAWER_REFILL_SELF_PERFORM_PERMISSION,
  CASH_DROP_PERFORM_PERMISSION,
  CASH_EXPENSE_CREATE_PERMISSION,
  CASH_EXPENSE_VOID_PERMISSION,
  CASH_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_VAULT_VIEW_PERMISSION,
  CASH_VAULT_COUNT_PERMISSION,
  CASH_VAULT_INTAKE_PERMISSION,
  CASH_VAULT_EXPENSE_CREATE_PERMISSION,
  CASH_VAULT_EXPENSE_VOID_PERMISSION,
  CASH_VAULT_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_TREASURY_VIEW_PERMISSION,
  CASH_TREASURY_FUND_PERMISSION,
  CASH_TREASURY_EXPENSE_CREATE_PERMISSION,
  CASH_TREASURY_EXPENSE_VOID_PERMISSION,
  CASH_TREASURY_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_TREASURY_COUNT_PERMISSION,
  CASH_TREASURY_COUNT_STARTING_PERMISSION,
  CASH_TREASURY_COUNT_OVERRIDE_PERMISSION,
  CASH_LOCATION_MANAGE_PERMISSION,
  CASH_NEEDED_REQUEST_CREATE_PERMISSION,
  CASH_NEEDED_REQUEST_VIEW_PERMISSION,
  CASH_NEEDED_REQUEST_CANCEL_PERMISSION,
  CASH_TREASURY_DISTRIBUTION_CREATE_PERMISSION,
  CASH_TREASURY_DISTRIBUTION_CANCEL_PERMISSION,
  CASH_VARIANCE_VIEW_PERMISSION,
  CASH_VARIANCE_SUBMIT_PERMISSION,
  CASH_VARIANCE_REVIEW_PERMISSION,
  CASH_VARIANCE_WRITEOFF_PERMISSION,
  CASH_VARIANCE_OFFSET_PERMISSION,
  CASH_VARIANCE_CLASSIFY_PERMISSION,
  CASH_DENOMINATIONS_CORRECT_OWN_PERMISSION,
  CASH_DENOMINATIONS_CORRECT_CUSTODY_PERMISSION,
  CASH_TREASURY_DELIVERY_RECEIVE_MATCHED_PERMISSION,
  CASH_TREASURY_DELIVERY_RECEIVE_PROVISIONAL_PERMISSION,
  CASH_TREASURY_DELIVERY_RECONCILE_PERMISSION,
  CASH_LOCAL_CUSTODY_CORRECT_PERMISSION,
  CASH_LOCAL_CUSTODY_REVERSE_PERMISSION,
  CASH_LOCAL_CUSTODY_VIEW_PERMISSION,
  CASH_OPERATING_MODEL_MANAGE_PERMISSION,
  CASH_REMITTANCE_DESTINATION_MANAGE_PERMISSION,
  CASH_MODE_ACTIVATION_PERFORM_PERMISSION,
  CASH_MODE_ACTIVATION_PERFORM_TREASURY_PERMISSION,
  CASH_VAULT_REMITTANCE_CREATE_PERMISSION,
  CASH_VAULT_REMITTANCE_PREPARE_PERMISSION,
  CASH_VAULT_REMITTANCE_HANDOFF_PERMISSION,
  CASH_VAULT_REMITTANCE_CANCEL_PERMISSION,
  CASH_VAULT_REMITTANCE_CONFIRM_DESTINATION_PERMISSION,
  CASH_VAULT_REMITTANCE_RETURN_PERMISSION,
  CASH_VAULT_REMITTANCE_EXCEPTION_PERMISSION,
  CASH_VAULT_REMITTANCE_VOID_PERMISSION,
  CASH_VAULT_REMITTANCE_RECEIVE_TREASURY_PERMISSION,
];

export const CASH_VARIANCE_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_VARIANCE_VIEW_PERMISSION,
  CASH_VARIANCE_SUBMIT_PERMISSION,
  CASH_VARIANCE_REVIEW_PERMISSION,
  CASH_VARIANCE_WRITEOFF_PERMISSION,
  CASH_VARIANCE_OFFSET_PERMISSION,
  CASH_VARIANCE_CLASSIFY_PERMISSION,
];

export const CASH_VARIANCE_CASE_ACCESS_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_VARIANCE_VIEW_PERMISSION,
  CASH_VARIANCE_REVIEW_PERMISSION,
  CASH_VARIANCE_WRITEOFF_PERMISSION,
  CASH_VARIANCE_OFFSET_PERMISSION,
  CASH_VARIANCE_CLASSIFY_PERMISSION,
];

export const CASH_NEEDED_REQUEST_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_NEEDED_REQUEST_CREATE_PERMISSION,
  CASH_NEEDED_REQUEST_VIEW_PERMISSION,
  CASH_NEEDED_REQUEST_CANCEL_PERMISSION,
];

export const CASH_DRAWER_REFILL_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_DRAWER_REFILL_PERFORM_PERMISSION,
  CASH_DRAWER_REFILL_SELF_PERFORM_PERMISSION,
];

export const CASH_VAULT_REMITTANCE_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_VAULT_REMITTANCE_CREATE_PERMISSION,
  CASH_VAULT_REMITTANCE_PREPARE_PERMISSION,
  CASH_VAULT_REMITTANCE_HANDOFF_PERMISSION,
  CASH_VAULT_REMITTANCE_CANCEL_PERMISSION,
  CASH_VAULT_REMITTANCE_CONFIRM_DESTINATION_PERMISSION,
  CASH_VAULT_REMITTANCE_RETURN_PERMISSION,
  CASH_VAULT_REMITTANCE_EXCEPTION_PERMISSION,
  CASH_VAULT_REMITTANCE_VOID_PERMISSION,
  CASH_VAULT_REMITTANCE_RECEIVE_TREASURY_PERMISSION,
];

export const CASH_TREASURY_DISTRIBUTION_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_TREASURY_DISTRIBUTION_CREATE_PERMISSION,
  CASH_TREASURY_DISTRIBUTION_CANCEL_PERMISSION,
];

export const CASH_TREASURY_COUNT_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_TREASURY_COUNT_PERMISSION,
  CASH_TREASURY_COUNT_STARTING_PERMISSION,
  CASH_TREASURY_COUNT_OVERRIDE_PERMISSION,
];

export const CASH_VAULT_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_VAULT_VIEW_PERMISSION,
  CASH_VAULT_COUNT_PERMISSION,
  CASH_VAULT_INTAKE_PERMISSION,
  CASH_VAULT_EXPENSE_CREATE_PERMISSION,
  CASH_VAULT_EXPENSE_VOID_PERMISSION,
  CASH_VAULT_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_VAULT_REMITTANCE_CREATE_PERMISSION,
  CASH_VAULT_REMITTANCE_PREPARE_PERMISSION,
  CASH_VAULT_REMITTANCE_HANDOFF_PERMISSION,
  CASH_VAULT_REMITTANCE_CANCEL_PERMISSION,
  CASH_VAULT_REMITTANCE_CONFIRM_DESTINATION_PERMISSION,
  CASH_VAULT_REMITTANCE_RETURN_PERMISSION,
  CASH_VAULT_REMITTANCE_EXCEPTION_PERMISSION,
  CASH_VAULT_REMITTANCE_VOID_PERMISSION,
];

export const CASH_TREASURY_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_TREASURY_VIEW_PERMISSION,
  CASH_TREASURY_FUND_PERMISSION,
  CASH_TREASURY_EXPENSE_CREATE_PERMISSION,
  CASH_TREASURY_EXPENSE_VOID_PERMISSION,
  CASH_TREASURY_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_TREASURY_COUNT_PERMISSION,
  CASH_TREASURY_COUNT_STARTING_PERMISSION,
  CASH_TREASURY_COUNT_OVERRIDE_PERMISSION,
  CASH_TREASURY_DISTRIBUTION_CREATE_PERMISSION,
  CASH_TREASURY_DISTRIBUTION_CANCEL_PERMISSION,
  CASH_TREASURY_DELIVERY_RECONCILE_PERMISSION,
  CASH_REMITTANCE_DESTINATION_MANAGE_PERMISSION,
  CASH_MODE_ACTIVATION_PERFORM_TREASURY_PERMISSION,
  CASH_VAULT_REMITTANCE_RECEIVE_TREASURY_PERMISSION,
];

export const CASH_DENOMINATION_REQUIREMENTS_READ_PERMISSION_KEYS: readonly PermissionKey[] = [
  CASH_SESSION_VIEW_PERMISSION,
  CASH_SESSION_OPEN_PERMISSION,
  CASH_SESSION_CLOSE_PERMISSION,
  CASH_EXPENSE_CREATE_PERMISSION,
  CASH_EXPENSE_VOID_PERMISSION,
  CASH_VAULT_VIEW_PERMISSION,
  CASH_VAULT_COUNT_PERMISSION,
  CASH_VAULT_INTAKE_PERMISSION,
  CASH_VAULT_EXPENSE_CREATE_PERMISSION,
  CASH_VAULT_EXPENSE_VOID_PERMISSION,
  CASH_TRANSFER_DRAWER_TO_DRAWER_PERMISSION,
  CASH_TRANSFER_DRAWER_TO_DRAWER_REVERSE_PERMISSION,
  CASH_DRAWER_REFILL_PERFORM_PERMISSION,
  CASH_DRAWER_REFILL_SELF_PERFORM_PERMISSION,
  CASH_DROP_PERFORM_PERMISSION,
  CASH_TREASURY_VIEW_PERMISSION,
  CASH_TREASURY_FUND_PERMISSION,
  CASH_TREASURY_EXPENSE_CREATE_PERMISSION,
  CASH_TREASURY_EXPENSE_VOID_PERMISSION,
  CASH_TREASURY_COUNT_PERMISSION,
  CASH_TREASURY_COUNT_STARTING_PERMISSION,
  CASH_TREASURY_COUNT_OVERRIDE_PERMISSION,
  CASH_VARIANCE_VIEW_PERMISSION,
  CASH_VARIANCE_SUBMIT_PERMISSION,
  CASH_VARIANCE_REVIEW_PERMISSION,
  CASH_VARIANCE_WRITEOFF_PERMISSION,
  CASH_VARIANCE_OFFSET_PERMISSION,
  CASH_VARIANCE_CLASSIFY_PERMISSION,
  CASH_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_VAULT_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_TREASURY_EXPENSE_CORRECT_METADATA_PERMISSION,
  CASH_DENOMINATIONS_CORRECT_OWN_PERMISSION,
  CASH_DENOMINATIONS_CORRECT_CUSTODY_PERMISSION,
  CASH_TREASURY_DELIVERY_RECEIVE_MATCHED_PERMISSION,
  CASH_TREASURY_DELIVERY_RECEIVE_PROVISIONAL_PERMISSION,
  CASH_TREASURY_DELIVERY_RECONCILE_PERMISSION,
  CASH_LOCAL_CUSTODY_CORRECT_PERMISSION,
  CASH_LOCAL_CUSTODY_REVERSE_PERMISSION,
  CASH_LOCAL_CUSTODY_VIEW_PERMISSION,
  CASH_OPERATING_MODEL_MANAGE_PERMISSION,
  CASH_REMITTANCE_DESTINATION_MANAGE_PERMISSION,
  CASH_MODE_ACTIVATION_PERFORM_PERMISSION,
  CASH_MODE_ACTIVATION_PERFORM_TREASURY_PERMISSION,
  ...CASH_VAULT_REMITTANCE_PERMISSION_KEYS,
];

export const PURCHASES_SETTLEMENT_PERMISSION_KEYS: readonly PermissionKey[] = [
  PURCHASES_SETTLEMENT_CHECK_PERMISSION,
  PURCHASES_SETTLEMENT_VOUCHER_PERMISSION,
  PURCHASES_SETTLEMENT_OVERRIDE_PERMISSION,
];

export const PURCHASES_SETTINGS_PERMISSION_KEYS: readonly PermissionKey[] = [
  PURCHASES_SETTINGS_MANAGE_PERMISSION,
];

export const DORIIS_REPORTS_PERMISSION_KEYS: readonly PermissionKey[] = [
  DORIIS_REPORTS_VIEW_PERMISSION,
  DORIIS_REPORTS_IMPORT_PERMISSION,
  DORIIS_REPORTS_MANUAL_CREATE_PERMISSION,
  DORIIS_REPORTS_LINK_PERMISSION,
  DORIIS_REPORTS_ENRICH_PERMISSION,
  DORIIS_REPORTS_UNLINK_PERMISSION,
];

export const UNIT_PROFILE_PERMISSION_KEYS: readonly PermissionKey[] = [
  UNIT_PROFILES_VIEW_PERMISSION,
  UNIT_PROFILES_MANAGE_PERMISSION,
  TARE_PROFILES_VIEW_PERMISSION,
  TARE_PROFILES_MANAGE_PERMISSION,
];
